import { Injectable, EventEmitter } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';

import { utils } from '../utils/utils';
import * as $ from 'jquery';
import { Producto } from '../models/producto';

@Injectable()
export class ProductoService {
    // public usuario:Array<any>;
   public headers = new Headers({'Content-Type': 'application/json; charset=utf-8', 'Accept': 'application/json, text/javascript, /;'});
    //public headers = new Headers({'Content-Type': 'application/json; charset=utf-8'});
   

    constructor(private _http: Http,  private _utils: utils) {
        this._utils = new utils();
    }
   
   
  consultarProductos(idRazonSocial): Observable<Producto[]>{
   
    let param = {
    idRazonSocial: idRazonSocial
  }
  const json = JSON.stringify(param);
   
  
      return this._http
        .post(`${this._utils.url}Producto/consultarProductos/`,json, {headers: this.headers}  )
        .map((response) => {
          try {
            if (response.json() !== 'null') {
              return JSON.parse(response.text());
            } else {
              return null;
            }
          } catch (e) {
            return null;
          }
        });
  }

  consultarProductosGrid(idRazonSocial): Observable<Producto[]>{
   
    let param = {
    idRazonSocial: idRazonSocial
  }
  const json = JSON.stringify(param);
   
  
      return this._http
        .post(`${this._utils.url}Producto/consultarProductosGrid/`,json, {headers: this.headers}  )
        .map((response) => {
          try {
            if (response.json() !== 'null') {
              return JSON.parse(response.text());
            } else {
              return null;
            }
          } catch (e) {
            return null;
          }
        });
  }


  consultarTipoProductos(idRazonSocial): Observable<Producto[]>{
   
    let param = {
    idRazonSocial: idRazonSocial
  }
  const json = JSON.stringify(param);
   
  
      return this._http
        .post(`${this._utils.url}Producto/consultarTipoProductos/`,json, {headers: this.headers}  )
        .map((response) => {
          try {
            if (response.json() !== 'null') {
              return JSON.parse(response.text());
            } else {
              return null;
            }
          } catch (e) {
            return null;
          }
        });
  }


  guardarProductoPrograma(listaProductos){
      
  const json = JSON.stringify(listaProductos);
   return this._http
          .post(`${this._utils.url}Producto/guardarProductoPrograma/`, json, {headers: this.headers} )
          .map((response) => {
            try {
              if(response.statusText !== 'null' && response.statusText == 'OK'){
                console.log(response.text());
                return response.statusText;
              }else{
                return null;
              }
            } catch (error) {
              console.log(error);
              return null; 
            } 
          });
  }



consultarProductosInventario(idRuta): Observable<Producto[]>{
   
    let param = {
    idRuta: idRuta
  }
  const json = JSON.stringify(param);
   
  
      return this._http
        .post(`${this._utils.url}Producto/consultarProductosInventario/`,json, {headers: this.headers}  )
        .map((response) => {
          try {
            if (response.json() !== 'null') {
              return JSON.parse(response.text());
            } else {
              return null;
            }
          } catch (e) {
            return null;
          }
        });
  }


  

  agregarProducto(producto: Producto){
 
  const json = JSON.stringify(producto);
   return this._http
          .post(`${this._utils.url}Producto/guardarProducto/`, json, {headers: this.headers} )
          .map((response) => {
            try {
              if(response.statusText !== 'null' && response.statusText == 'OK'){
                console.log(response.text());
                return response.statusText;
              }else{
                return null;
              }
            } catch (error) {
              console.log(error);
              return null; 
            } 
          });
  }

  actualizarProducto(producto: Producto){
 
    const json = JSON.stringify(producto);
     return this._http
            .post(`${this._utils.url}Producto/actualizarProducto/`, json, {headers: this.headers} )
            .map((response) => {
              try {
                if(response.statusText !== 'null' && response.statusText == 'OK'){
                  console.log(response.text());
                  return response.statusText;
                }else{
                  return null;
                }
              } catch (error) {
                console.log(error);
                return null; 
              } 
            });
    }

  eliminarProducto(producto){
 
  const json = JSON.stringify(producto);
   return this._http
          .post(`${this._utils.url}Producto/eliminarProducto/`, json, {headers: this.headers} )
          .map((response) => {
            try {
              if(response.statusText !== 'null' && response.statusText == 'OK'){
                console.log(response.text());
                return response.statusText;
              }else{
                return null;
              }
            } catch (error) {
              console.log(error);
              return null; 
            } 
          });
  }


  consultarProducto(idProducto): Observable<Producto>{
   
    let param = {
    idProducto: idProducto
  }
  const json = JSON.stringify(param);
   
  
      return this._http
        .post(`${this._utils.url}Producto/consultarProducto/`,json, {headers: this.headers}  )
        .map((response) => {
          try {
            if (response.json() !== 'null') {
              return JSON.parse(response.text());
            } else {
              return null;
            }
          } catch (e) {
            return null;
          }
        });
  }


 
   

}